import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';

import './Submenu/nav-submenu.scss';

export const SurveySolution = ({ title, url }) => {
  return (
    <a key={title} className="sm-nav-submenu__link-item" href={url}>
      <Typography color="link">{title}</Typography>
    </a>
  );
};

export default SurveySolution;

SurveySolution.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
